import { Box, Typography, useMediaQuery } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { useTheme } from '@mui/material/styles';

interface IncludeImageButtonProps {
  isChecked?: boolean;
  onClick?: () => void;
}

export default function IncludeImageButton({
  isChecked,
  onClick,
}: IncludeImageButtonProps) {
  return (
    <Box
      sx={{
        color: '#007CDC',
        border: '1px solid #F8C807',
        borderRadius: '16px',
        p: '4px 8px',
        cursor: 'pointer',
        background: '#FFF6D2',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        ml: '4px',
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          height: '12px',
          width: '12px',
          backgroundColor: '#fff',
          borderRadius: '3px',
          border: '1px solid #F8C807',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {isChecked && (
          <CheckIcon
            sx={{
              height: '10px',
              width: '10px',
              color: '#000',
              stroke: '#000',
              strokeWidth: 2,
            }}
          />
        )}
      </Box>
      <Typography color="#000" variant="smallText">
        Include Image
      </Typography>
    </Box>
  );
}
